
export default {

    data() {
        return {
            componentName: this.$options.name
        }
    },

    methods: {
        trans(key) {
            if (!TRANSLATIONS[this.componentName] || !TRANSLATIONS[this.componentName][key]) {
                console.warn(`Translation for ${this.componentName}.${key} not found.`);
                return key;
            }

            return TRANSLATIONS[this.componentName][key];
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/admin/js/app-components/TranslationsUtils.js